import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Theme from '../../theme';

import MobileHeader from './MobileHeader';
import MobileMenu from './MobileMenu';
import DesktopHeader from './DesktopHeader';

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  height: 64px;
  ${Theme.media.lg`
  display: flex;
  align-items: center;
  height: 120px;
  `};
  background-color: ${Theme.colours.white};
  border-top: 4px solid ${Theme.colours.singtelred};
  box-shadow: 0 2px 5px 0 ${Theme.colours.grey_d6};
  z-index: 99999;
`;

class Header extends PureComponent {
  state = {
    isHamburgerMenuOpen: false,
    menuHoverKey: -1,
    activeSubMenuItem: -1,
    activeMenuItem: -1,
    isSearchActive: false
  };

  handleDesktopMenuMouseEnter = key => {
    this.setState({
      menuHoverKey: key
    });
  };

  handleDesktopMenuMouseLeave = () => {
    this.setState({
      menuHoverKey: -1
    });
  };

  handleHamburgerClick = () => {
    this.setState(prevState => ({
      isHamburgerMenuOpen: !prevState.isHamburgerMenuOpen
    }));
  };

  handleMobileMenuItemClick = (menuKey, subKey) => {
    this.setState(prevState => {
      return {
        activeMenuItem: menuKey,
        // Allows us to close the "accordion" feel by toggling on and off
        activeSubMenuItem: prevState.activeSubMenuItem !== subKey ? subKey : -1
      };
    });
  };

  handleSearchClick = () => {
    this.setState(prevState => {
      return { isSearchActive: !prevState.isSearchActive };
    });
  };

  render() {
    const {
      baseUrl,
      logo,
      loginUrl,
      shoppingCartUrl,
      showHamburger,
      menuItems,
      showSearch,
      showLoginButton,
      isCheckOutPage,
      showShoppingCart,
      showAvatar,
      avatarMenuItems,
      firstLevelLinks
    } = this.props;
    const {
      isHamburgerMenuOpen,
      activeMenuItem,
      activeSubMenuItem,
      menuHoverKey,
      isSearchActive
    } = this.state;

    const checkOutMenuItems = [
      {
        item: {
          active: true,
          title: 'Checkout'
        }
      }
    ];

    return (
      <StyledHeader>
        <MobileHeader
          baseUrl={baseUrl}
          loginUrl={loginUrl}
          logoAlt={logo.alt}
          logoLink={logo.link}
          onHamburgerClick={this.handleHamburgerClick}
          shoppingCartUrl={shoppingCartUrl}
          showHamburger={!isCheckOutPage && showHamburger}
          showLoginButton={!isCheckOutPage && showLoginButton}
          showAvatar={!isCheckOutPage && showAvatar}
          avatarMenuItems={avatarMenuItems}
          showSearch={!isCheckOutPage && showSearch}
          showShoppingCart={!isCheckOutPage && showShoppingCart}
          showVeriSignLogo={isCheckOutPage}
        />
        <DesktopHeader
          baseUrl={baseUrl}
          firstLevelLinks={firstLevelLinks}
          isSearchActive={isSearchActive}
          loginUrl={!isCheckOutPage && loginUrl}
          logoAlt={logo.alt}
          logoLink={logo.link}
          menuHoverKey={menuHoverKey}
          menuItems={isCheckOutPage ? checkOutMenuItems : menuItems}
          onMenuMouseEnter={this.handleDesktopMenuMouseEnter}
          onMenuMouseLeave={this.handleDesktopMenuMouseLeave}
          onSearchClick={this.handleSearchClick}
          showAvatar={!isCheckOutPage && showAvatar}
          avatarMenuItems={avatarMenuItems}
          showLoginButton={!isCheckOutPage && showLoginButton}
          showTopRHSMenuItems={!isCheckOutPage && firstLevelLinks}
          showSearch={!isCheckOutPage && showSearch}
          showShoppingCart={!isCheckOutPage && showShoppingCart}
          showVeriSignLogo={isCheckOutPage}
          shoppingCartUrl={!isCheckOutPage && shoppingCartUrl}
        />
        {/* The mobile menu that toggles when clicking hamburger icon */}
        <MobileMenu
          baseUrl={baseUrl}
          activeSubMenuItem={activeSubMenuItem}
          activeMenuItem={activeMenuItem}
          firstLevelLinks={firstLevelLinks}
          isHamburgerMenuOpen={isHamburgerMenuOpen}
          logoAlt={logo.alt}
          logoLink={logo.link}
          menuItems={menuItems}
          onClose={this.handleHamburgerClick}
          onMenuItemClick={this.handleMobileMenuItemClick}
        />
      </StyledHeader>
    );
  }
}

Header.defaultProps = {
  baseUrl: '',
  logo: {
    alt: 'Singtel.com',
    link: '#'
  },
  menuItems: []
};

Header.propTypes = {
  /** Base url for absolute paths */
  baseUrl: PropTypes.string,
  /** Menu items for Avatar */
  avatarMenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
      onClick: PropTypes.func
    })
  ),
  /** First level links */
  firstLevelLinks: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      title: PropTypes.string,
      href: PropTypes.string
    })
  ),
  /** Display check-out view */
  isCheckOutPage: PropTypes.bool,
  /** Logo */
  logo: PropTypes.shape({
    alt: PropTypes.string,
    link: PropTypes.string
  }),
  /** Menu items */
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        active: PropTypes.bool,
        title: PropTypes.string,
        href: PropTypes.string
      }).isRequired,
      subMenu: PropTypes.arrayOf(
        PropTypes.shape({
          item: PropTypes.object,
          subMenu: PropTypes.array
        })
      )
    }).isRequired
  ),
  /** Show Login button */
  showLoginButton: PropTypes.bool,
  /** Login URL */
  loginUrl: PropTypes.string,
  /** Show avatar icon (logged in state) */
  showAvatar: PropTypes.bool,
  /** Show shopping cart icon */
  showShoppingCart: PropTypes.bool,
  /** Shopping Cart URL */
  shoppingCartUrl: PropTypes.string,
  /** Show hamburger menu */
  showHamburger: PropTypes.bool,
  /** Show Search field */
  showSearch: PropTypes.bool
};

export default Header;
